/**
 *
 *   Shopify Analytics
 *       - An integration into hydrogen to push analytics to shopify
 *
 **/
"use client";
import Config from "@/config";
import {
	AnalyticsEventName,
	getClientBrowserParameters,
	sendShopifyAnalytics,
	ShopifySalesChannel
} from "@shopify/hydrogen-react";
import { useLocale } from "next-intl";
import { usePathname } from "next/navigation";

const SHOP_ID = Config.shopId;

export function useShopifyAnalytics() {
	const locale = useLocale();
	const pathname = usePathname();
	// Send page view event
	const sendPageView = (eventName, payload) => {
		return sendShopifyAnalytics({
			eventName,
			payload: {
				...getClientBrowserParameters(),
				hasUserConsent: true,
				shopifySalesChannel: ShopifySalesChannel.headless,
				shopId: `gid://shopify/Shop/${SHOP_ID}`,
				currency: Config.currency,
				acceptedLanguage: locale,
				...payload
			}
		});
	};

	// Send add to cart event
	const sendAddToCart = ({ cartId, totalValue, products }) =>
		sendPageView(AnalyticsEventName.ADD_TO_CART, {
			cartId,
			totalValue,
			products
		});

	return {
		sendPageView,
		sendAddToCart,
		pathname
	};
}
